import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Flex, Link, Image } from '@chakra-ui/react'

import logo from './logo.png'
import HeaderProfile from 'containers/HeaderProfile'

export const Header = ({ hideProfile = false, ...props }) => (
  <Flex as='nav' padding={3} borderBottomWidth='1px' {...props}>
    <Flex alignItems='center' align='center' mr={5}>
      <Link as={RouterLink} to='/'>
        <Image height='40px' src={logo} alt='logotipo ia.tic.gov.pt' />
      </Link>
    </Flex>
    <Flex alignItems='center' flexGrow={1} />
    {!hideProfile && <HeaderProfile />}
  </Flex>
)

export default Header
